export enum PickerMode {
    popup,
    dialog
}